define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/arr.js
// module id = AHT0
// module chunks = 0 1